// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Alert,
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   FormControlLabel,
//   MenuItem,
//   Paper,
//   Radio,
//   RadioGroup,
//   Stack,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { saleService } from "../../services";

// const PAYMENT_OPTIONS = [
//   { value: "CASH", label: "Efectivo", helper: "Pago inmediato con cambio" },
//   { value: "TRANSFER", label: "Transferencia", helper: "Queda esperando aprobacion" },
//   { value: "VOUCHER", label: "Voucher", helper: "Voucher o autorizacion requerida" },
// ];

// const toMoney = (value) => {
//   const parsed = Number(value);
//   if (!Number.isFinite(parsed)) return "Q0.00";
//   return `Q${parsed.toFixed(2)}`;
// };

// const todayValue = () => {
//   const now = new Date();
//   const yyyy = now.getFullYear();
//   const mm = `${now.getMonth() + 1}`.padStart(2, "0");
//   const dd = `${now.getDate()}`.padStart(2, "0");
//   return `${yyyy}-${mm}-${dd}`;
// };

// const sanitizeNonNegativeDecimal = (value) => {
//   if (value === "") return "";
//   const parsed = Number(value);
//   if (!Number.isFinite(parsed)) return null;
//   if (parsed < 0) return null;
//   return value;
// };

// function SalePaymentDialog({
//   open,
//   onCancel,
//   onConfirm,
//   total = 0,
//   itemsCount = 0,
//   hasOpenCashSession = false,
//   transferAccounts = [],
//   loadingTransferAccounts = false,
//   submitting = false,
// }) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const [form, setForm] = useState({
//     payment_method: "CASH",
//     cash_received: "0.00",
//     reference: "",
//     bank: "",
//     account_id: "",
//     payment_date: todayValue(),
//   });
//   const [methodConfig, setMethodConfig] = useState([]);

//   const totalNumber = useMemo(() => {
//     const parsed = Number(total || 0);
//     return Number.isFinite(parsed) ? parsed : 0;
//   }, [total]);

//   useEffect(() => {
//     if (!open) return;
//     setForm({
//       payment_method: "CASH",
//       cash_received: totalNumber.toFixed(2),
//       reference: "",
//       bank: "",
//       account_id: "",
//       payment_date: todayValue(),
//     });
//   }, [open, totalNumber]);

//   useEffect(() => {
//     if (!open) return;
//     saleService
//       .listPaymentMethodConfig()
//       .then((rows) => setMethodConfig(Array.isArray(rows) ? rows : []))
//       .catch(() => setMethodConfig([]));
//   }, [open]);

//   const enabledMethods = useMemo(() => {
//     const activeCodes = new Set(
//       methodConfig.filter((row) => row?.is_active !== false).map((row) => String(row.code || "").toUpperCase())
//     );
//     activeCodes.add("CASH");
//     return PAYMENT_OPTIONS.filter((option) => activeCodes.has(option.value));
//   }, [methodConfig]);

//   const method = form.payment_method;
//   const cashReceived = Number(form.cash_received || 0);
//   const cashChange = Number.isFinite(cashReceived) ? cashReceived - totalNumber : 0;
//   const referenceRequired = method === "TRANSFER" || method === "VOUCHER";
//   const reference = String(form.reference || "").trim();
//   const canConfirmCash = Number.isFinite(cashReceived) && cashReceived >= totalNumber;
//   const hasReference = !referenceRequired || reference.length > 0;
//   const hasTransferAccount =
//     method !== "TRANSFER" || (String(form.account_id || "").trim().length > 0);

//   const confirmDisabled =
//     submitting ||
//     !enabledMethods.some((option) => option.value === method) ||
//     !hasOpenCashSession ||
//     totalNumber <= 0 ||
//     !hasReference ||
//     !hasTransferAccount ||
//     (method === "CASH" && !canConfirmCash);

//   const handleChangeMethod = (nextMethod) => {
//     if (!nextMethod) return;
//     setForm((prev) => ({
//       ...prev,
//       payment_method: nextMethod,
//       cash_received: nextMethod === "CASH" ? (prev.cash_received || totalNumber.toFixed(2)) : "",
//     }));
//   };

//   const handleNumberFieldChange = (field, value) => {
//     const safeValue = sanitizeNonNegativeDecimal(value);
//     if (safeValue === null) return;
//     setForm((prev) => ({ ...prev, [field]: safeValue }));
//   };

//   const handleConfirm = () => {
//     if (confirmDisabled) return;
//     const payload = {
//       payment_method: method,
//       amount: totalNumber.toFixed(2),
//       cash_received: method === "CASH" ? String(form.cash_received || totalNumber.toFixed(2)) : undefined,
//       reference: reference,
//       bank: method === "TRANSFER" ? String(form.bank || "").trim() : "",
//       account_id: method === "TRANSFER" ? Number(form.account_id || 0) : undefined,
//       payment_date: method === "TRANSFER" ? String(form.payment_date || "") : "",
//     };
//     onConfirm?.(payload);
//   };

//   return (
//     <Dialog open={Boolean(open)} onClose={onCancel} fullWidth maxWidth="md">
//       <DialogTitle>Cobrar venta</DialogTitle>
//       <DialogContent dividers>
//         <Box
//           sx={{
//             pt: 0.4,
//             display: "grid",
//             gridTemplateColumns: isMobile ? "1fr" : "1fr 1.2fr",
//             gap: 1.5,
//           }}
//         >
//           <Paper variant="outlined" sx={{ p: 1.2 }}>
//             <Stack spacing={0.8}>
//               <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
//                 Resumen
//               </Typography>
//               <Stack direction="row" justifyContent="space-between">
//                 <Typography variant="body2" color="text.secondary">
//                   Items
//                 </Typography>
//                 <Typography variant="body2">{itemsCount}</Typography>
//               </Stack>
//               <Stack direction="row" justifyContent="space-between">
//                 <Typography variant="body2" color="text.secondary">
//                   Total
//                 </Typography>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "primary.main" }}>
//                   {toMoney(totalNumber)}
//                 </Typography>
//               </Stack>
//               {method === "CASH" && (
//                 <Stack direction="row" justifyContent="space-between">
//                   <Typography variant="body2" color="text.secondary">
//                     Cambio
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     color={cashChange < 0 ? "error.main" : "text.primary"}
//                     sx={{ fontWeight: 700 }}
//                   >
//                     {toMoney(cashChange)}
//                   </Typography>
//                 </Stack>
//               )}
//             </Stack>
//           </Paper>

//           <Stack spacing={1.2}>
//             {!hasOpenCashSession && (
//               <Alert severity="warning">Debe abrir caja para confirmar el cobro.</Alert>
//             )}

//             <RadioGroup
//               row={!isMobile}
//               value={method}
//               onChange={(event) => handleChangeMethod(event.target.value)}
//             >
//               {enabledMethods.map((option) => (
//                 <Paper
//                   key={option.value}
//                   variant="outlined"
//                   sx={{
//                     p: 0.7,
//                     flex: 1,
//                     borderColor:
//                       method === option.value ? theme.palette.primary.main : theme.palette.divider,
//                     bgcolor:
//                       method === option.value
//                         ? theme.palette.action.selected
//                         : theme.palette.background.paper,
//                     mb: !isMobile ? 0 : 0.8,
//                   }}
//                 >
//                   <FormControlLabel
//                     value={option.value}
//                     control={<Radio size="small" />}
//                     label={
//                       <Box>
//                         <Typography variant="body2" sx={{ fontWeight: 700 }}>
//                           {option.label}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {option.helper}
//                         </Typography>
//                       </Box>
//                     }
//                     sx={{ m: 0, width: "100%" }}
//                   />
//                 </Paper>
//               ))}
//             </RadioGroup>

//             {method === "CASH" ? (
//               <TextField
//                 label="Efectivo recibido"
//                 size="small"
//                 type="number"
//                 value={form.cash_received}
//                 onChange={(event) => handleNumberFieldChange("cash_received", event.target.value)}
//                 inputProps={{ min: 0, step: "0.01" }}
//                 error={form.cash_received !== "" && !canConfirmCash}
//                 helperText={!canConfirmCash ? "Debe ser mayor o igual al total." : " "}
//                 fullWidth
//               />
//             ) : (
//               <Stack spacing={1}>
//                 <TextField
//                   label={method === "VOUCHER" ? "Voucher/Autorizacion" : "Referencia/Boleta"}
//                   size="small"
//                   value={form.reference}
//                   onChange={(event) => setForm((prev) => ({ ...prev, reference: event.target.value }))}
//                   error={referenceRequired && !hasReference}
//                   helperText={referenceRequired && !hasReference ? "Campo obligatorio." : " "}
//                   fullWidth
//                 />
//                 {method === "TRANSFER" && (
//                   <>
//                     <TextField
//                       select
//                       label="Cuenta destino"
//                       size="small"
//                       value={form.account_id}
//                       onChange={(event) => setForm((prev) => ({ ...prev, account_id: event.target.value }))}
//                       error={!hasTransferAccount}
//                       helperText={!hasTransferAccount ? "Selecciona una cuenta autorizada." : " "}
//                       disabled={loadingTransferAccounts}
//                       fullWidth
//                     >
//                       {transferAccounts.map((account) => (
//                         <MenuItem key={account.id} value={String(account.id)}>
//                           {account.name} - {account.bank_name} ({account.account_number})
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                     <TextField
//                       label="Fecha (opcional)"
//                       size="small"
//                       type="date"
//                       value={form.payment_date}
//                       onChange={(event) => setForm((prev) => ({ ...prev, payment_date: event.target.value }))}
//                       InputLabelProps={{ shrink: true }}
//                       fullWidth
//                     />
//                   </>
//                 )}
//               </Stack>
//             )}
//           </Stack>
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onCancel} disabled={submitting}>
//           Cancelar
//         </Button>
//         <Button
//           variant="contained"
//           color={method === "TRANSFER" ? "primary" : "success"}
//           onClick={handleConfirm}
//           disabled={confirmDisabled}
//         >
//           Confirmar pago
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default SalePaymentDialog;
import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardActionArea,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  AttachMoney,
  CreditCard,
  Payments,
  SwapHoriz,
} from "@mui/icons-material";
import { saleService } from "../../services";

const PAYMENT_METHODS = {
  CASH: {
    label: "Efectivo",
    description: "Pago inmediato con cambio",
    icon: AttachMoney,
    color: "#2E7D32",
  },
  TRANSFER: {
    label: "Transferencia",
    description: "Queda esperando aprobación",
    icon: SwapHoriz,
    color: "#1565C0",
  },
  VOUCHER: {
    label: "Voucher",
    description: "Voucher o autorización requerida",
    icon: CreditCard,
    color: "#6A1B9A",
  },
};

const toMoney = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "Q0.00";
  return `Q${parsed.toFixed(2)}`;
};

const todayValue = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = `${now.getMonth() + 1}`.padStart(2, "0");
  const dd = `${now.getDate()}`.padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const sanitizeNonNegativeDecimal = (value) => {
  if (value === "") return "";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  if (parsed < 0) return null;
  return value;
};

function SalePaymentDialog({
  open,
  onCancel,
  onConfirm,
  total = 0,
  itemsCount = 0,
  hasOpenCashSession = false,
  transferAccounts = [],
  loadingTransferAccounts = false,
  submitting = false,
}) {
  const theme = useTheme();

  const [form, setForm] = useState({
    payment_method: "CASH",
    cash_received: "0.00",
    reference: "",
    bank: "",
    account_id: "",
    payment_date: todayValue(),
  });
  const [methodConfig, setMethodConfig] = useState([]);

  const totalNumber = useMemo(() => {
    const parsed = Number(total || 0);
    return Number.isFinite(parsed) ? parsed : 0;
  }, [total]);

  useEffect(() => {
    if (!open) return;
    setForm({
      payment_method: "CASH",
      cash_received: totalNumber.toFixed(2),
      reference: "",
      bank: "",
      account_id: "",
      payment_date: todayValue(),
    });
  }, [open, totalNumber]);

  useEffect(() => {
    if (!open) return;
    saleService
      .listPaymentMethodConfig()
      .then((rows) => setMethodConfig(Array.isArray(rows) ? rows : []))
      .catch(() => setMethodConfig([]));
  }, [open]);

  const enabledMethods = useMemo(() => {
    const activeCodes = new Set(
      methodConfig
        .filter((row) => row?.is_active !== false)
        .map((row) => String(row.code || "").toUpperCase())
    );
    activeCodes.add("CASH");
    return Object.entries(PAYMENT_METHODS)
      .filter(([code]) => activeCodes.has(code))
      .map(([code, config]) => ({ code, ...config }));
  }, [methodConfig]);

  const method = form.payment_method;
  const cashReceived = Number(form.cash_received || 0);
  const cashChange = Number.isFinite(cashReceived) ? cashReceived - totalNumber : 0;
  const referenceRequired = method === "TRANSFER" || method === "VOUCHER";
  const reference = String(form.reference || "").trim();
  const canConfirmCash = Number.isFinite(cashReceived) && cashReceived >= totalNumber;
  const hasReference = !referenceRequired || reference.length > 0;
  const hasTransferAccount =
    method !== "TRANSFER" || String(form.account_id || "").trim().length > 0;

  const confirmDisabled =
    submitting ||
    !enabledMethods.some((m) => m.code === method) ||
    !hasOpenCashSession ||
    totalNumber <= 0 ||
    !hasReference ||
    !hasTransferAccount ||
    (method === "CASH" && !canConfirmCash);

  const handleChangeMethod = (nextMethod) => {
    if (!nextMethod) return;
    setForm((prev) => ({
      ...prev,
      payment_method: nextMethod,
      cash_received:
        nextMethod === "CASH"
          ? prev.cash_received || totalNumber.toFixed(2)
          : "",
    }));
  };

  const handleNumberFieldChange = (field, value) => {
    const safeValue = sanitizeNonNegativeDecimal(value);
    if (safeValue === null) return;
    setForm((prev) => ({ ...prev, [field]: safeValue }));
  };

  const handleConfirm = () => {
    if (confirmDisabled) return;
    const payload = {
      payment_method: method,
      amount: totalNumber.toFixed(2),
      cash_received:
        method === "CASH"
          ? String(form.cash_received || totalNumber.toFixed(2))
          : undefined,
      reference: reference,
      bank: method === "TRANSFER" ? String(form.bank || "").trim() : "",
      account_id:
        method === "TRANSFER" ? Number(form.account_id || 0) : undefined,
      payment_date:
        method === "TRANSFER" ? String(form.payment_date || "") : "",
    };
    onConfirm?.(payload);
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          overflow: "hidden",
          background: theme.palette.background.paper,
        },
      }}
    >
      <DialogTitle sx={{ pb: 0 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: alpha(theme.palette.primary.main, 0.08),
              color: theme.palette.primary.main,
            }}
          >
            <Payments fontSize="small" />
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Cobrar venta
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {itemsCount} {itemsCount === 1 ? "item" : "items"} · Total{" "}
              <Typography
                component="span"
                variant="caption"
                sx={{ fontWeight: 700, color: "primary.main" }}
              >
                {toMoney(totalNumber)}
              </Typography>
            </Typography>
          </Box>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 1 }}>
        <Stack spacing={2}>
          {!hasOpenCashSession && (
            <Alert severity="warning" sx={{ borderRadius: 1.5, py: 0.5 }}>
              Debe abrir caja para confirmar el cobro.
            </Alert>
          )}

          {/* Métodos de pago */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
          >
            {enabledMethods.map(({ code, label, icon: Icon, color }) => {
              const isSelected = method === code;
              return (
                <Card
                  key={code}
                  variant="outlined"
                  sx={{
                    flex: 1,
                    borderRadius: 1.5,
                    borderColor: isSelected ? color : alpha(theme.palette.divider, 0.4),
                    bgcolor: isSelected ? alpha(color, 0.03) : "transparent",
                    borderWidth: isSelected ? 1.5 : 1,
                    transition: "all 0.15s ease",
                    "&:hover": {
                      borderColor: alpha(color, 0.5),
                      bgcolor: alpha(color, 0.02),
                    },
                  }}
                >
                  <CardActionArea
                    onClick={() => handleChangeMethod(code)}
                    sx={{ p: 1.25 }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon
                        fontSize="small"
                        sx={{ color: isSelected ? color : "text.secondary" }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: isSelected ? 600 : 400,
                          color: isSelected ? color : "text.primary",
                          fontSize: "0.85rem",
                        }}
                      >
                        {label}
                      </Typography>
                    </Stack>
                  </CardActionArea>
                </Card>
              );
            })}
          </Stack>

          <Divider sx={{ my: 0.5 }} />

          {/* Campos */}
          {method === "CASH" ? (
            <Stack spacing={1.5}>
              <TextField
                label="Efectivo recibido"
                size="small"
                type="number"
                value={form.cash_received}
                onChange={(event) =>
                  handleNumberFieldChange("cash_received", event.target.value)
                }
                inputProps={{ min: 0, step: "0.01" }}
                error={form.cash_received !== "" && !canConfirmCash}
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1.5,
                  },
                }}
              />

              {cashReceived > 0 && Number.isFinite(cashChange) && (
                <Box
                  sx={{
                    p: 1.25,
                    borderRadius: 1.5,
                    bgcolor:
                      cashChange >= 0
                        ? alpha(theme.palette.success.main, 0.05)
                        : alpha(theme.palette.error.main, 0.05),
                    border: `1px solid ${
                      cashChange >= 0
                        ? alpha(theme.palette.success.main, 0.15)
                        : alpha(theme.palette.error.main, 0.15)
                    }`,
                  }}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography variant="caption" color="text.secondary">
                      Cambio
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: cashChange >= 0 ? "success.main" : "error.main",
                      }}
                    >
                      {toMoney(cashChange)}
                    </Typography>
                  </Stack>
                </Box>
              )}
            </Stack>
          ) : (
            <Stack spacing={1.5}>
              <TextField
                label={
                  method === "VOUCHER" ? "Voucher / Autorización" : "Referencia / Boleta"
                }
                size="small"
                value={form.reference}
                onChange={(event) =>
                  setForm((prev) => ({ ...prev, reference: event.target.value }))
                }
                error={referenceRequired && !hasReference}
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1.5,
                  },
                }}
              />

              {method === "TRANSFER" && (
                <>
                  <TextField
                    select
                    label="Cuenta destino"
                    size="small"
                    value={form.account_id}
                    onChange={(event) =>
                      setForm((prev) => ({
                        ...prev,
                        account_id: event.target.value,
                      }))
                    }
                    error={!hasTransferAccount}
                    disabled={loadingTransferAccounts}
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                      },
                    }}
                  >
                    {transferAccounts.length === 0 ? (
                      <MenuItem disabled value="">
                        {loadingTransferAccounts
                          ? "Cargando..."
                          : "Sin cuentas"}
                      </MenuItem>
                    ) : (
                      transferAccounts.map((account) => (
                        <MenuItem key={account.id} value={String(account.id)}>
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            sx={{ width: "100%", gap: 1 }}
                          >
                            <Typography variant="body2">
                              {account.bank_name} - {account.name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {account.account_number}
                            </Typography>
                          </Stack>
                        </MenuItem>
                      ))
                    )}
                  </TextField>

                  <TextField
                    label="Fecha"
                    size="small"
                    type="date"
                    value={form.payment_date}
                    onChange={(event) =>
                      setForm((prev) => ({
                        ...prev,
                        payment_date: event.target.value,
                      }))
                    }
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                      },
                    }}
                  />
                </>
              )}
            </Stack>
          )}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, pt: 1, gap: 1 }}>
        <Button
          onClick={onCancel}
          disabled={submitting}
          size="small"
          sx={{ borderRadius: 1.5, px: 2.5, color: "text.secondary" }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={confirmDisabled}
          size="small"
          startIcon={<Payments fontSize="small" />}
          sx={{
            borderRadius: 1.5,
            px: 2.5,
            bgcolor:
              method === "TRANSFER"
                ? theme.palette.primary.main
                : theme.palette.success.main,
            "&:hover": {
              bgcolor:
                method === "TRANSFER"
                  ? theme.palette.primary.dark
                  : theme.palette.success.dark,
            },
            boxShadow: "none",
          }}
        >
          Confirmar pago
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SalePaymentDialog;
